import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=7337887c&comments=true"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"
import style0 from "./newsList.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports